export const FETCH_LOAN_EMPLOYEES_DDL = "FETCH_LOAN_EMPLOYEES_DDL";
